export default __webpack_public_path__ + "static/GT-America-Compressed-Medium-4bc26ebec1ff90e0d79b26470cccf487.woff";